const { ORANGE_THEME } = require("./orange");
const { GREEN_THEME } = require("./green");
const { AG_THEME } = require("./ag");

module.exports = {
  DEFAULT_THEME: GREEN_THEME,
  ORANGE_THEME,
  AG_THEME,
};
